import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormModalService} from "../../../root/form-modal/form-modal.service";
import {SessionService} from "../../../core/session.service";

@Component({
    selector: 'general-settings',
    providers: [],
    templateUrl: './general-settings.component.html'
})
export class GeneralSettingsComponent{

    @Input() generalValues: any;
    name: string = "general-settings";
    title: string = "restrictions.GENERAL_CONFIG.MODAL.title";
    openModal;
    constructor(private formModalService: FormModalService, private session:SessionService){
    }

    openFormModal(event) {
        this.openModal = true;

        this.formModalService.showFormModal(this.name, ()=>{
            this.sendOpen();
        });
    }

    sendOpen(){
        this.openModal = false;
    }

    @Output() updateGeneralRestriction:EventEmitter<any> = new EventEmitter<any>();

    updateGeneralSetting(item){
        this.updateGeneralRestriction.emit(item);
    }

    hideActionButtons(){
        return !this.session.loggedUserAllowed('PERM_RESTRICTIONS_EDIT')
    };
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/general-settings/general-settings.component.ts